import * as React from 'react';
import useEffect from './use_effect';
import isElementOverflowing from './is_element_overflowing';
/**
 * Checks if an element's content has overflow.
 *
 * Element to be checked.
 * @param ref
 *
 * Callback which fires after the overflow has been checked.
 * @param callback
 *
 * Defines if will check horizontal or vertical overflow.
 * @param isVertical
 */
var useIsOverflow = _ref => {
  var {
    ref,
    callback,
    isVertical,
    checkResize,
    dependencies
  } = _ref;
  var [isOverflow, setIsOverflow] = React.useState(false);
  useEffect(() => {
    var {
      current
    } = ref;
    if (!current) return;
    var trigger = () => {
      var hasOverflow = isElementOverflowing(current, isVertical);
      setIsOverflow(hasOverflow);
      if (callback) callback(hasOverflow);
    };
    if (checkResize) {
      var handleResize = () => {
        trigger();
      };
      window.addEventListener('resize', handleResize);

      // Initial check
      trigger();
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    } else {
      // Initial check without resize listener
      trigger();
    }
  }, [callback, isVertical, ref, checkResize, dependencies]);
  return isOverflow;
};
export default useIsOverflow;